<template>
  <div class="compact-form">
    <osv-app-alert osv-alert-position="osv-alert-relative" />

    <alert-message
      type="info"
      v-if="unlocked"
      :messages="$t('yourAccountIsUnlocked')"
    />

    <alert-message
      type="info"
      v-if="confirmed"
      :messages="$t('yourAccountIsConfirmed')"
    />

    <form @submit.prevent="login" v-if="!this.isLoggedIn">
      <!-- Email -->
      <div class="form-group">
        <b-field :label="$t('email')" label-position="on-border">
          <b-input
            v-model="email"
            required
            type="email"
          />
        </b-field>
      </div>

      <!-- Password -->
      <div class="form-group">
        <b-field :label="$t('password')" label-position="on-border">
          <b-input
            v-model="password"
            required
            type="password"
            :password-reveal="true"
          />
        </b-field>
      </div>

      <div class="form-group">
        <b-checkbox v-model="rememberMe">
          {{ $t("stayConnect") }}
        </b-checkbox>
      </div>

      <div class="text-right form-group">
        <a
          v-if="this.osvConfig.paths.signUp"
          :href="this.osvConfig.paths.signUp"
        >
          <b-button
            type="is-link is-light"
            rounded
          >
            {{ $t("signUp") }}
          </b-button>
        </a>
        <b-button
          outlined
          type="is-primary"
          native-type="submit"
          rounded
          :loading="loadingSignIn"
        >
          {{ $t("connect") }}
        </b-button>
      </div>
      <div
        v-if="this.osvConfig.paths.resetPassword"
        class="text-right mt-2"
      >
        <a :href="this.osvConfig.paths.resetPassword">
          {{ $t("resetPassword") }}
        </a>
      </div>
    </form>

    <div v-else>
      <alert-message :messages="[$t('youAreConnected')]" type="success" />
      <p class="text-center text-grey mb-4">
        {{ $t("willBeRedirected") }}
      </p>
    </div>
  </div>
</template>

<script>
import { LocaleMixin } from "@/mixins/LocaleMixin";
import { HelpersMixin } from "@/mixins/HelpersMixin";
import { ConfigMixin } from "@/mixins/ConfigMixin";
import AlertMessage from "../components/shared/AlertMessage";
import store from "@/store";
import VueI18n from "vue-i18n";
import OsvAppAlert from "@/components/shared/OsvAppAlert";

export default {
  store,
  name: "SignInForm",
  mixins: [LocaleMixin, HelpersMixin, ConfigMixin],
  components: { OsvAppAlert, AlertMessage },

  data() {
    return {
      email: "",
      password: "",
      rememberMe: true,
      errorMessage: [],
      showError: false,
      redirectTo: null,
      unlocked: null,
      confirmed: null,

      loadingSignIn: false
    };
  },

  computed: {
    isLoggedIn: function() {
      return store.getters["auth/isLoggedIn"];
    }
  },

  created() {
    let urlParams = new URLSearchParams(window.location.search);
    this.redirectTo = urlParams.get("redirect_to");
    this.unlocked = urlParams.get("unlocked");
    this.confirmed = urlParams.get("confirmed");
  },

  // Translate component
  mounted() {
    this.$i18n.locale = this.getLocale();

    // Redirect customer if is already connected
    if (this.isLoggedIn && this.osvConfig.paths.account) {
      document.location.href = this.osvConfig.paths.account;
    }
  },

  methods: {
    login: function() {
      this.errorMessage = [];
      let data = {
        email: this.email,
        password: this.password,
        rememberMe: this.rememberMe
      };

      if (this.loadingSignIn) { return false; }
      this.loadingSignIn = true;

      store
        .dispatch("auth/login", data)
        .then(() => {
          if (this.redirectTo) {
            document.location.href = this.redirectTo;
          } else if (this.osvConfig.paths.account) {
            document.location.href = this.osvConfig.paths.account;
          } else {
            document.location.href = '/';
          }
        })
        .catch(err => {
          this.$root.$emit('OsvAlert_ErrorFromApi', err, 'online_account')
        })
        .finally(() => {
          this.loadingSignIn = false;
        });
    },

    logout: function() {
      store.dispatch("auth/logout");
    }
  },

  i18n: new VueI18n({
    locale: "fr",
    messages: {
      en: {
        email: "Email",
        password: "Password",
        connect: "Connect",
        disconnect: "Disconnect",
        resetPassword: "Forgot your password?",
        signUp: "Create my account",
        youAreConnected: "You are connected",
        willBeRedirected: "You will be redirected",
        connexionError: "An error occurred during connection",
        notAuthorizedError: "Incorrect email or password",
        account: "My account",
        stayConnect: "Stay connected",
        yourAccountIsUnlocked: "Your account is unlocked.",
        yourAccountIsConfirmed: "Your email address is confirmed."
      },
      fr: {
        email: "Email",
        password: "Mot de passe",
        connect: "Connexion",
        disconnect: "Me déconnecter",
        resetPassword: "Mot de passe oublié ?",
        signUp: "Créer mon compte",
        youAreConnected: "Vous êtes connecté·e",
        willBeRedirected: "Vous allez être redirigé·e.",
        connexionError: "Une erreur s'est produite lors de la connexion",
        notAuthorizedError: "Email ou mot de passe incorrecte",
        account: "Mon compte",
        stayConnect: "Rester connecté·e",
        yourAccountIsUnlocked: "Votre compte est débloqué.",
        yourAccountIsConfirmed: "Votre adresse e-mail est confirmée."
      }
    }
  })
};
</script>

<style lang="scss" src="../assets/styles/buefy/base.scss"></style>
